import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import "./save.toast.css";

const SaveToast = ({ isError = false, message, onDismiss, onRetry }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!message || isError) {
      return undefined;
    }

    const dismissOnNextClick = () => onDismiss();
    const timeoutId = setTimeout(() => {
      window.addEventListener("click", dismissOnNextClick, { once: true });
    }, 0);

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("click", dismissOnNextClick);
    };
  }, [isError, message, onDismiss]);

  if (!message) {
    return null;
  }

  return (
    <div className={`save-toast${isError ? " save-toast--error" : ""}`} role={isError ? "alert" : "status"}>
      <span>{message}</span>
      {isError && (
        <div className="save-toast__actions">
          <button type="button" onClick={onRetry}>
            {t("common.retry")}
          </button>
          <button type="button" onClick={onDismiss}>
            {t("common.close")}
          </button>
        </div>
      )}
    </div>
  );
};

export default SaveToast;
